import { getBookingBackend } from "../../../../app/backend";
import { WorkplaceBooking } from "../../../../features/Checkin/typings";
import { useRemoteQuery } from "../../useRemote/useRemoteQuery";

export const useRemoteFetchCheckinInfo = (uid: string | undefined) => {
  return useRemoteQuery<WorkplaceBooking[]>({
    queryKey: ["get-checkin-info"],
    url: `${getBookingBackend()}/checkin/${uid}`,
    enabled: !!uid
  });
};
